export default __webpack_public_path__ + "67818213eb90c4d450efa375e57929a7.svg";